// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605191813/js/" + chunkId + "." + {"44":"777b837d","225":"7d7a83e8","481":"9c358040","486":"406290e3","770":"9f1a4fcc"}[chunkId] + ".0.16287403089549013.chunk.js";
};